import React from 'react';
import { Shield, Clock, Users, Award } from 'lucide-react';
import { features, stats } from '../data/mock';

const featureIcons = [Shield, Clock, Users, Award];

const About = () => {
  return (
    <section id="hakkimizda" className="py-24 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Hakkımızda
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Yılların deneyimi ile güvenilir taşımacılık hizmeti
          </p>
          <div className="w-20 h-1 bg-blue-500 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Text Content */}
          <div>
            <h3 className="text-2xl font-semibold text-white mb-6">
              Güvenli ve Konforlu Yolculuklar
            </h3>
            <p className="text-slate-300 leading-relaxed mb-6">
              Sağlık Tur olarak, öğrenci servisi, personel taşımacılığı ve turizm 
              alanlarında uzun yıllardır hizmet vermekteyiz. Modern araç filomuz ve 
              deneyimli kadromuz ile müşterilerimize güvenli, konforlu ve zamanında 
              ulaşım hizmeti sunuyoruz.
            </p>
            <p className="text-slate-300 leading-relaxed">
              Müşteri memnuniyetini ön planda tutarak, her yolculuğu özel kılmayı 
              hedefliyoruz. Şeffaf fiyatlandırma politikamız ve 7/24 müşteri 
              desteğimiz ile her zaman yanınızdayız.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const IconComponent = featureIcons[index];
              return (
                <div
                  key={feature.id}
                  className="bg-slate-900/50 border border-slate-700 rounded-xl p-6 hover:border-blue-500/30 transition-colors duration-300"
                >
                  <IconComponent className="w-10 h-10 text-blue-400 mb-4" />
                  <h4 className="text-lg font-semibold text-white mb-2">
                    {feature.title}
                  </h4>
                  <p className="text-slate-400 text-sm">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-blue-400 mb-2">
                {stat.value}
              </div>
              <div className="text-slate-400 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
